import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiInstagram, FiFacebook } = FiIcons;

export default function Footer() {
  return (
    <footer className="bg-brand-primaryDark text-brand-white pt-16 pb-8 border-t border-[#3b4485]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h2 className="text-2xl font-bold text-brand-white mb-4">Otso Co.</h2>
            <p className="text-gray-300 max-w-xs mb-2">
              Social media that gets your pet business booked.
            </p>
            <p className="text-brand-blush text-sm">Based in Laurel, Maryland</p>
          </div>
          
          <div className="flex flex-col space-y-3">
            <h3 className="text-lg font-semibold mb-2">Quick Links</h3>
            <Link to="/" className="text-gray-300 hover:text-brand-blush transition-colors text-sm">Home</Link>
            <Link to="/services/social-media-management" className="text-gray-300 hover:text-brand-blush transition-colors text-sm">Social Media Management</Link>
            <Link to="/services/consulting" className="text-gray-300 hover:text-brand-blush transition-colors text-sm">1:1 Consulting</Link>
            <Link to="/lead-funnel-score" className="text-gray-300 hover:text-brand-blush transition-colors text-sm">Lead Funnel Score</Link>
            <Link to="/pet-content-planner" className="text-gray-300 hover:text-brand-blush transition-colors text-sm">Free Content Planner</Link>
            <Link to="/about" className="text-gray-300 hover:text-brand-blush transition-colors text-sm">About</Link>
            <Link to="/contact" className="text-gray-300 hover:text-brand-blush transition-colors text-sm">Contact</Link>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>
            <p className="text-gray-300 mb-2">Email: <a href="mailto:hello@otsoco.com" className="hover:text-brand-blush">hello@otsoco.com</a></p>
            <div className="flex space-x-4 mt-6">
              <a href="https://facebook.com/theperrydasilva" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-300 hover:text-brand-blush">
                <SafeIcon icon={FiFacebook} className="h-6 w-6" />
              </a>
              <a href="https://instagram.com/theperrydasilva" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-300 hover:text-brand-blush">
                <SafeIcon icon={FiInstagram} className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-[#1a1a1a] bg-[#1a1a1a] -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8 py-6 mt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>© {new Date().getFullYear()} Otso Co. All rights reserved.</p>
          <p className="mt-2 md:mt-0">Helping pet care businesses grow online.</p>
        </div>
      </div>
    </footer>
  );
}